import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient, private router: Router) {}

  postData(form: FormData, url: string): void {
    this.http.post(url, form).subscribe(
      (res) => {
        this.router.navigate(['request-ack']);
      },
      (err) => {
        alert(
          'در ثبت پیام مشکلی بوجود آمده است. لطفا دوباره تلاش نمایید و یا با پشتیبانی کارگزاری تماس حاصل فرمایید'
        );
        console.log('error in sending mail', err);
      }
    );
  }

  getData(url, options) {
    return this.http.get(url, options);
  }
}
